import { Tooltip, withStyles } from '@material-ui/core';

export const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#eee',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(10),
        border: '1px solid #dadde9',
    },
}))(Tooltip);